import STYLES from './MenuItem.module.scss';

import { startMenuIconData } from '../../../../../../../images/imageData';

const MenuItem = ({ text, icon, href }) => {
  const imageSrc = icon || startMenuIconData.fallback;
  return (
    <a href={href} target="_blank" className={STYLES.MenuItem} rel="noreferrer">
      <img className={STYLES.MenuItem__image} src={imageSrc} alt={text} />
      <span className={STYLES.MenuItem__name}>{text}</span>
      <span className={STYLES.MenuItem__arrow}>►</span>
    </a>
  );
};

export default MenuItem;
